import * as THREE from 'three';
import {gsap} from "gsap";
import { Observer } from "gsap/Observer";

import vertexShader from './glsl/vertexShader.glsl';
import gooeyShader from './glsl/gooeyShader.glsl';

export default class Figure {
    constructor(scene, cb) {
        this.container = document.getElementById('apply');
        this.canvas = document.getElementById('stage');
        this.$image = document.querySelector('.apply-background__image');
        this.title = document.getElementById('apply-content');
        this.scene = scene;

        this.loader = new THREE.TextureLoader();
        this.image = this.loader.load(this.$image.src, (texture) => {
            this.hover = this.loader.load(this.$image.dataset.hover, () => {
                this.start();
            });
        });
        this.$image.style.opacity = 0;

        this.sizes = new THREE.Vector2(0, 0);
        this.offset = new THREE.Vector2(0, 0);
        this.mouse = new THREE.Vector2(0, 0);
        this.clock = new THREE.Clock();
        this.duration = .5;

        window.addEventListener('resize', () => { this.onResize() })
    }

    start() {
        this.getSizes();
        this.createMesh();
        this.observer();
    }

    getSizes() {
        const {width, height} = this.container.getBoundingClientRect();

        this.sizes.set(width, height);
    }

    createMesh() {
        let {width, height, top} = this.container.getBoundingClientRect();

        this.uniforms = {
            u_alpha: { value: 1 },
            u_image: { type: 't', value: this.image },
            u_imagehover: { type: 't', value: this.hover },
            u_mouse: { value: this.mouse },
            u_time: { value: 0 },
            u_res: {
                value: new THREE.Vector2(width, height)
            },
            u_progressHover: { value: 0 },
            u_radius: { value: 50 / window.innerWidth },
        }

        this.geometry = new THREE.PlaneGeometry(1,1,1,1);
        this.material = new THREE.ShaderMaterial({
            uniforms: this.uniforms,
            vertexShader: vertexShader,
            fragmentShader: gooeyShader,
            defines: {
                PI: Math.PI,
                PR: window.devicePixelRatio.toFixed(1)
            }
        });

        this.mesh = new THREE.Mesh(this.geometry, this.material);
        this.mesh.position.set(0, 0, 0);
        this.mesh.scale.set(this.sizes.x, this.sizes.y, 1);

        this.scene.add(this.mesh);
    }

    onMouseMove(x, y) {
        let {width, height, top, bottom} = this.canvas.getBoundingClientRect();
        let {left: l, right: r, top: t, bottom: b} = this.title.getBoundingClientRect();

        // detect if mouse is over title
        if (x > l && x < r && y > t && y < b) {
            this.onMouseLeave();

            return;
        }
        else {
            if(!this.isHovering || this.uniforms.u_progressHover.value === 0) {
                this.onMouseEnter();
            }
        }

        gsap.to(this.mouse, {
            duration: 0.5,
            x: (x / width) * 2 - 1,
            y: (-((y - top)/ height) * 2 + 1) * (height/width),
        });
    }

    onMouseEnter() {
        this.isHovering = true

        gsap.to(this.uniforms.u_progressHover, {
            duration: 0.5,
            value: 1,
        })
    }

    onMouseLeave() {
        gsap.to(this.uniforms.u_progressHover, {
            duration: 0.5,
            value: 0,
            onComplete: () => {
                this.isHovering = false
            }
        })
    }

    // use arrow function to bind `this` to the class
    observer() {
        Observer.create({
            target: "#apply",
            type: "touch, pointer",
            onHover: (self) => {
                this.onMouseEnter();
            },
            onHoverEnd: (self) => {
                this.onMouseLeave();
            },
            onMove: (self) => {
                this.onMouseMove(self.x, self.y);
            },
        });
    }

    update() {
        if (!this.mesh || !this.isHovering) 
            return

        this.uniforms.u_time.value += this.clock.getDelta()
    }

    onResize() {
        if(window.innerWidth >= 992) {
            this.getSizes();

            this.scene.remove(this.mesh);
            this.createMesh();

            this.$image.style.opacity = 0;
            return;
        }

        this.$image.style.opacity = 1;
    }
}